<div [hidden]="!hasPermissionToSearch">
  <dx-lookup #partnerLookup
    [dataSource]="partnerDataSource"
    [disabled]="isReadOnly"
    displayExpr="PartnerName"
    [minSearchLength]="minSearchLength"
    [showClearButton]="true"
    (onValueChanged)="partnerSelectedInternal($event)"
    [isValid]="!isRequired">
    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
    <div *dxTemplate="let partner of 'item'">
      @if (!partner.moreResultTemplate && !partner.restrictionTemplate) {
        <div>
          <p class="list-group-item-text">
            <strong>{{partner.PartnerName}}</strong> ({{partner.PartnerTypeName}})
          </p>
          <p class="list-group-item-text">
            {{partner.MainIdentificationName}}: {{partner.MainIdentificationValue}}
          </p>
          <p class="list-group-item-text">
            <em>{{partner.EdiPortalId}}</em>
          </p>
        </div>
      }
      @if (partner.moreResultTemplate) {
        <div class="alert alert-success">
          There are more results - please limit your search
        </div>
      }
      @if (partner.restrictionTemplate) {
        <div class="alert alert-success">
          Result limited by data restriction
        </div>
      }
    </div>
  </dx-lookup>
</div>
<div [hidden]="hasPermissionToSearch">
  <i>You don't have the required permission (Partner_View_Search) to perform a partner search.</i>
</div>
@if (showLoadingPartnerDetails && loadingPartnerDetails) {
  <span>
    <img src="../../images/ajax-loader.gif" alt="Loading partner details..." /> Loading partner details...
  </span>
}
